const PLUGIN_NAME = 'list-query-variables-plugin';
const BOOST_PROPS = {
  name: 5,
  oemPartNo: 10,
  productCode: 10
};

export { PLUGIN_NAME, BOOST_PROPS };
